import { fetcher } from "@weezevent/weezjs-core";

// GET ALL POPULATIONS
export const getAllPopulations = ({ organizationId, eventId, params = {} }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/populations`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

// DELETE POPULATION
export const removePopulation = ({ organizationId, eventId, id }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/populations/${id}`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.delete(endpoint, {
		...options,
		cache: false
	});
};

// CREATE A NEW POPULATION
export const createPopulation = ({ organizationId, eventId, data }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/populations`;

	const options = {
		data,
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.post(endpoint, {
		...options,
		cache: false
	});
};

// GET BY ONE POPULATION
export const getPopulation = (
	organizationId,
	eventId,
	populationId,
	params = {}
) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/populations/${populationId}`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};
	return fetcher.get(endpoint, options);
};

// UPDATE POPULATION
export const updatePopulation = ({ organizationId, eventId, id, data }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/populations/${id}`;
	const options = {
		data,
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.patch(endpoint, {
		...options,
		cache: false
	});
};
